import React, { Component } from 'react';
import { ApiUrls } from '@api/apiUrls';
import { keyMap } from '@locales/lokalise/keyMap';
import { fetchApi } from 'api/fetchApi';
import ErrorView from 'components/shared/errorView';
import { IFormField } from 'components/shared/forms/formField.interface';
// @ts-ignore: remove after translating into typescript
import generator from 'components/shared/forms/formGenerator';
import Preloader from 'components/shared/preloader';
import QForm from 'components/user/qforms/form';
import { QFormRecordType } from 'components/user/qforms/qforms.types';
import { Q_FORM_STATUS } from 'global.enums';
import { handleError } from 'utils/errors';

interface IMamInvestorTerminateLPOAQFormProps {
  isVerify?: boolean;
  withoutVerify?: boolean;
  qFormType: string;
  title?: string;
  tradingAccountId?: number;
}

interface IMamInvestorTerminateLPOAQFormState {
  processing: boolean;
  activeForm: QFormRecordType | null;
  errMsg: string;
  terminationEnabled: boolean;
  form: IForm;
}

interface IForm {
  terminateCheckbox: false;
  [key: string]: boolean;
}

const TERMINATE_LPOA_FIELDS: IFormField[] = [
  {
    name: 'terminateCheckbox',
    type: 'checkbox',
    title: keyMap.mamTerminateConfirmation,
    attributes: {
      autoComplete: 'off',
    },
    validator: {
      check: (value) => value === true,
      message: keyMap.formsValidationRequiredError,
    },
  },
];

// eslint-disable-next-line max-len
export class MamInvestorTerminateLPOAQForm extends Component<
  IMamInvestorTerminateLPOAQFormProps,
  IMamInvestorTerminateLPOAQFormState
> {
  state: IMamInvestorTerminateLPOAQFormState = {
    processing: true,
    activeForm: null,
    errMsg: '',
    terminationEnabled: false,
    form: { terminateCheckbox: false },
  };

  form = generator(TERMINATE_LPOA_FIELDS);

  componentDidMount() {
    void this.getSingleQForm();
  }

  onChange = (name: string, value: boolean): void => {
    const { form } = this.state;

    form[name] = value;
    this.setState({ form });
  };

  getSingleQForm = async (): Promise<void> => {
    const { qFormType, tradingAccountId } = this.props;

    this.setState({ activeForm: null, processing: true });

    try {
      const response = await fetchApi.get<QFormRecordType>(ApiUrls.qFormUser.getSingleQForm, {
        params: {
          type: qFormType,
          tradingAccountId,
        },
      });

      const { data } = response;

      this.setState({
        activeForm: data,
        processing: false,
        terminationEnabled: data.status === Q_FORM_STATUS.COMPLETED,
      });
    } catch (error) {
      this.setState({ processing: false, errMsg: error.response.data });
      handleError(keyMap.sharedErrorsFailedToGetRecord, error);
    }
  };

  onSubmit = async (): Promise<void> => {
    const { activeForm } = this.state;

    if (activeForm == null) {
      return;
    }

    const { id } = activeForm;

    const endpoint = `${ApiUrls.qFormUser.createTerminationRequest}?qFormId=${id}`;

    try {
      this.setState({ processing: true, terminationEnabled: false });

      await fetchApi.post(endpoint);

      this.setState({ processing: false });
    } catch (error) {
      this.setState({ processing: false, errMsg: error.response.data });
      handleError(keyMap.sharedErrorsFailedToSaveRecord, error);
    }
  };

  render(): JSX.Element {
    const { qFormType, tradingAccountId } = this.props;
    const { processing, errMsg, activeForm, terminationEnabled, form } = this.state;

    const TerminateForm = this.form;

    const actions = [
      {
        title: keyMap.mamTerminateLPOA,
        onClick: this.onSubmit,
        className: 'btn light--button',
        type: 'submit',
      },
    ];

    if (processing || !activeForm) {
      return <Preloader />;
    }

    if (errMsg) {
      return <ErrorView error={errMsg} />;
    }

    return (
      <div>
        {terminationEnabled && (
          <div className="form-box">
            <TerminateForm onChange={this.onChange} form={form} actions={actions} />
          </div>
        )}
        <QForm
          id={activeForm.id}
          tradingAccountId={tradingAccountId}
          className={activeForm.className}
          classNameKey={activeForm.classNameKey}
          qFormType={qFormType}
          status={activeForm.status}
          refresh={this.getSingleQForm}
        />
      </div>
    );
  }
}
